import { StoreApi, UseBoundStore } from "zustand";

import { CreateFileInput, FileProductInput } from "./__generated/gql/graphql";

export type TillFileInput = Omit<CreateFileInput, "sortingIndex">;

export interface State {
	isLatest: boolean;
	token: string | null;
	companyId: string | null;
	till: {
		isOpen: boolean;
		isEditingFileInput: boolean;
		selectedCategoryId: string | null;
		selectedProductId: string | null;
		tempProductInput: FileProductInput | null;
		createFileInput: TillFileInput | null;
		updateFileInput: TillFileInput | null;
		fileInputSnapshot: TillFileInput | null;
	};
}

export interface Actions {
	resetApp: (data?: Partial<State>) => void;
	setIsLatest: (data: State["isLatest"]) => void;
	setToken: (data: State["token"]) => void;
	setCompanyId: (data: State["companyId"]) => void;
	resetTill: () => void;
	setTillIsOpen: (data: State["till"]["isOpen"]) => void;
	setTillIsEditingFileInput: (
		data: State["till"]["isEditingFileInput"],
	) => void;
	setTillSelectedCategoryId: (
		data: State["till"]["selectedCategoryId"],
	) => void;
	setTillSelectedProductId: (data: State["till"]["selectedProductId"]) => void;
	updateTillTempProductInput: (
		data: Partial<State["till"]["tempProductInput"]>,
	) => void;
	updateTillCreateFileInput: (
		data: Partial<State["till"]["createFileInput"]>,
	) => void;
	updateTillUpdateFileInput: (
		data: Partial<State["till"]["updateFileInput"]>,
	) => void;
	updateTillFileInputSnapshot: (
		data: Partial<State["till"]["fileInputSnapshot"]>,
	) => void;
}

// Helpers to autogenerate selectors
type WithSelectors<S> = S extends { getState: () => infer T }
	? S & { use: { [K in keyof T]: () => T[K] } }
	: never;

export const createSelectors = <S extends UseBoundStore<StoreApi<object>>>(
	_store: S,
) => {
	const store = _store as WithSelectors<typeof _store>;
	store.use = {};
	for (const k of Object.keys(store.getState())) {
		(store.use as any)[k] = () => store((s) => s[k as keyof typeof s]);
	}

	return store;
};
